module.exports = __webpack_public_path__ + "static/af-nav-bg-633396f33ae501ac8aafc68f1b1151ac.jpg";